import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import '././login.css'
import { loginUser, logout } from "../../helper/Context/action";
import { useAuthDispatch, useAuthState } from "../../helper/Context/context";


export const LogIn = () => {

    const navigate = useNavigate();

    const dispatch = useAuthDispatch();
    const userDetails = useAuthState();

    const { UserID, token, RoleID } = userDetails

    const [Invalid, setInvalid] = useState('')
    const [loading, setloading] = useState(false)
    const [Validationerror, setValidationerror] = useState(false)
    const [Loginmessage, setLoginmessage] = useState('')

    const [UserName, setUserName] = useState("")
    const [Password, setPassword] = useState("")

    React.useEffect(() => {
        logout(dispatch)
    }, [])

    const handleLogin = async () => {
        setLoginmessage('')
        if (UserName !== '' && Password !== '') {
            try {
                let response = await loginUser(dispatch, { UserName, Password, setloading, handleRollIdWiseDashboard, handleErrorIdWiseDashboard, setLoginmessage });
                if (!response) return;

            } catch (error) {
                console.log(error);
            }
            setValidationerror("")
        } else {
            setValidationerror("Error")
        }
    }

    const handleRollIdWiseDashboard = (data) => {
        if (data?.access_token) {
            // console.log('#########', data)
            navigate(`/MainDashboard`)
        }
    }

    const handleErrorIdWiseDashboard = (data) => {
        setLoginmessage(data)
    }

    const showPass = () => {
        var x = document.getElementById("pass");
        var y = document.getElementById("eye");
        if (x.type == "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
        if (y.className === "fa fa-eye-slash") {
            y.className = "fa fa-eye";
        } else {
            y.className = "fa fa-eye-slash";
        }
    }

    // back button function
    const handelBack = () => {
        navigate('/')
    }

    return (
        <div className="container-fluid p-0">
            <div className="Center_item" style={{ height: '100vh', overflow: 'hidden', padding: '0px' }}>

                <div className='row  px-4 px-lg-0' >

                    <div className="col-12 col-md-10 d-flex justify-content-end rounded shadow  pb-3 pt-2" style={{ background: '#efefef', position: 'relative' }} >

                        <div className='row g-0 py-4'>

                            <button
                                type="button"
                                onClick={handelBack}
                                title="Go back"
                                className="text-start"
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: 'auto',          // ✅ IMPORTANT
                                    display: 'inline-flex',
                                    background: 'transparent',
                                    border: 'none',
                                    padding: '10px',
                                    cursor: 'pointer',
                                    color: '#13334F',
                                    fontWeight:'bold'
                                    // border:'1px solid blue'
                                }}
                            >
                                <i className="fa-solid fa-arrow-left text-primary me-1 mt-1"></i>
                                Home
                            </button>

                            <div className="text-center pb-4">
                                <img src="./Static/Assets/Img/logo.png" alt="" srcset=""
                                    className="logo_in_circle" />

                                <h6 className="pt-3  pb-0 fw-bold text-center fs-5" style={{ color: '#13334F', }}>
                                    Marine Insurance Learning <br /> &   <br /> Sharing Online</h6>
                            </div>

                            <div className='col-9 mx-auto'>
                                <form action="#" method="post">

                                    <div className="input-group mb-3" style={{ height: '38px' }}>
                                        <span className="input-group-text1" id="basic-addon1">
                                            <i class="fa-solid fa-user"></i>
                                        </span>

                                        <input
                                            type="text"
                                            className="form-control f7 Customborder"
                                            placeholder="Username"
                                            aria-describedby="basic-addon1"
                                            value={UserName}
                                            onChange={(e) => setUserName(e.target.value)}
                                        />

                                    </div>

                                    <div className="input-group mb-4 mt-3" style={{ height: '38px' }}>
                                        <span className="input-group-text1 border ">
                                            <i className="fa-solid fa-key"></i>
                                        </span>

                                        <input
                                            type="password"
                                            id="pass"
                                            placeholder="Password"
                                            className="form-control f7 Customborder"
                                            value={Password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />

                                        <span className="input-group-text1" onClick={showPass}>
                                            <i id='eye' className="fas fa-eye"></i>
                                        </span>

                                    </div>

                                    <button
                                        onClick={() => handleLogin()}
                                        id=""
                                        type="button"
                                        value="Login"
                                        className="btn btn_submit fw-bold form-control text-white " >
                                        {
                                            loading ?
                                                <i
                                                    className="fa fa-spinner fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                                :
                                                "Login"
                                        }
                                    </button>

                                    <div className="col-12 text-danger mt-lg-2 mb-lg-2 text-center">{Loginmessage}</div>
                                </form>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}
